// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__asI5q","label":"Category_label__j-m_I","content":"Category_content__374ME","header":"Category_header__6oK0A","location":"Category_location__37XWy"};